module.exports = __webpack_public_path__ + "img/seo_thumbnail.a66c3fca.jpg";